import request from '@/utils/request'

// 获取系统配置
export function getSystemConfig() {
  return request({
    url: '/api/system/config',
    method: 'get'
  })
}

// 更新系统配置
export function updateSystemConfig(config) {
  return request({
    url: '/api/system/config',
    method: 'put',
    data: config
  })
}

// 获取基础配置
export function getBasicConfig() {
  return request({
    url: '/api/system/config/basic',
    method: 'get'
  })
}

// 更新基础配置
export function updateBasicConfig(config) {
  return request({
    url: '/api/system/config/basic',
    method: 'put',
    data: config
  })
}

// 获取安全配置
export function getSecurityConfig() {
  return request({
    url: '/api/system/config/security',
    method: 'get'
  })
}

// 更新安全配置
export function updateSecurityConfig(config) {
  return request({
    url: '/api/system/config/security',
    method: 'put',
    data: config
  })
}

// 获取邮件配置
export function getEmailConfig() {
  return request({
    url: '/api/system/config/email',
    method: 'get'
  })
}

// 更新邮件配置
export function updateEmailConfig(config) {
  return request({
    url: '/api/system/config/email',
    method: 'put',
    data: config
  })
}

// 测试邮件配置
export function testEmailConfig(config) {
  return request({
    url: '/api/system/config/email/test',
    method: 'post',
    data: config
  })
}

// 获取存储配置
export function getStorageConfig() {
  return request({
    url: '/api/system/config/storage',
    method: 'get'
  })
}

// 更新存储配置
export function updateStorageConfig(config) {
  return request({
    url: '/api/system/config/storage',
    method: 'put',
    data: config
  })
}

// 获取服务端配置
export function getServerConfig() {
  return request({
    url: '/api/system/config/server',
    method: 'get'
  })
}

// 更新服务端配置
export function updateServerConfig(config) {
  return request({
    url: '/api/system/config/server',
    method: 'put',
    data: config
  })
}

// 初始化服务器密钥
export function initServerSecret() {
  return request({
    url: '/api/system/config/server/init-secret',
    method: 'post'
  })
}

// 清理存储
export function cleanupStorage(days) {
  return request({
    url: '/api/system/config/storage/cleanup',
    method: 'post',
    data: { days }
  })
}

// 获取系统信息
export function getSystemInfo() {
  return request({
    url: '/api/system/info',
    method: 'get'
  })
}

// 获取系统状态
export function getSystemStatus() {
  return request({
    url: '/api/system/status',
    method: 'get'
  })
}

// 重启系统
export function restartSystem() {
  return request({
    url: '/api/system/restart',
    method: 'post'
  })
}

// 关闭系统
export function shutdownSystem() {
  return request({
    url: '/api/system/shutdown',
    method: 'post'
  })
}

// 获取服务器监控信息
export function getServerMonitorInfo() {
  return request({
    url: '/api/v1/system/monitor',
    method: 'get'
  })
}